'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledTools = require('styled-tools');

var _materialIconsReact = require('material-icons-react');

var _materialIconsReact2 = _interopRequireDefault(_materialIconsReact);

var _grid = require('@rebass/grid');

var _LoadingIndicator = require('../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _theme = require('../../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// MaterialIcon does not pass on props to the icon it renders (we need className),
// so we cannot directly wrap it with styled components
var MaterialIconWrapper = function MaterialIconWrapper(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(_materialIconsReact2.default, props)
  );
};
MaterialIconWrapper.propTypes = { className: _propTypes2.default.string.isRequired };

var BaseButton = _styledComponents2.default.button.withConfig({
  displayName: 'Button__BaseButton',
  componentId: 'sc-1g8cliq-0'
})(['-webkit-font-smoothing:antialiased;-webkit-touch-callout:none;box-sizing:border-box;display:inline-block;font-size:12px;font-weight:bold;letter-spacing:0.05em;padding:0 ', ';text-transform:uppercase;cursor:pointer;outline:none;transition:background-color 0.15s;line-height:24px;white-space:nowrap;', ''], (0, _styledTools.ifProp)({ large: true }, '24px', '16px'), function (props) {
  var buttonVariant = (0, _theme.getTheme)(props).buttons[props.variant];

  return '\n      height: ' + (buttonVariant.height || (props.large ? '48px' : '32px')) + ';\n      min-width: ' + (buttonVariant.width || (props.large ? '96px' : '72px')) + ';\n      width: ' + (buttonVariant.width || 'auto') + ';\n      background-color: ' + (buttonVariant.backgroundColor || 'transparent') + ';\n      box-shadow: ' + (buttonVariant.boxShadow || 'none') + ';\n      color: ' + (buttonVariant.color || _theme.colors.black54) + ';\n      border: ' + (buttonVariant.border || 'none') + ';\n      border-radius: ' + (buttonVariant.borderRadius || '2px') + ';\n\n      &:hover {\n        background-color: ' + buttonVariant.hoverColor + ';\n      }\n\n      &:active {\n        background-color: ' + buttonVariant.activeColor + ';\n      }\n\n      &:focus {\n        background-color: ' + buttonVariant.focusColor + ';\n      }\n    ';
});

var StyledButtonIcon = (0, _styledComponents2.default)(MaterialIconWrapper).withConfig({
  displayName: 'Button__StyledButtonIcon',
  componentId: 'sc-1g8cliq-1'
})(['display:flex;&:first-child{margin-right:8px;}&:last-child{margin-left:8px;}&:only-child{margin:0;}i{color:', ' !important;}'], function (props) {
  return (0, _theme.getTheme)(props).buttons[props.variant].color;
});

var Button = function Button(props) {
  return _react2.default.createElement(
    BaseButton,
    props,
    _react2.default.createElement(
      _grid.Flex,
      { alignItems: 'center', justifyContent: 'center' },
      (props.icon && props.iconPosition === 'left' || props.variant === 'icon') && _react2.default.createElement(StyledButtonIcon, { variant: props.variant, icon: props.icon }),
      props.loading && _react2.default.createElement(_LoadingIndicator2.default, { color: (0, _theme.getTheme)(props).buttons[props.variant].color || _theme.colors.black54 }),
      !props.loading && props.variant !== 'icon' && _react2.default.createElement(
        'span',
        null,
        props.children
      ),
      props.icon && props.iconPosition === 'right' && _react2.default.createElement(StyledButtonIcon, { variant: props.variant, icon: props.icon })
    )
  );
};

Button.propTypes = {
  loading: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.string]),
  icon: _propTypes2.default.string,
  iconPosition: _propTypes2.default.oneOf(['right', 'left']),
  variant: _propTypes2.default.oneOf(['primary', 'secondary', 'link', 'destructive', 'icon'])
};

Button.defaultProps = {
  loading: false,
  children: 'Button',
  icon: null,
  iconPosition: 'left',
  variant: 'secondary',
  iconOnly: false
};

exports.default = (0, _styledComponents.withTheme)(Button);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/Button/index.js
// module id = 530
// module chunks = 29